if (!customElements.get('mms-subscription-details')) {
  customElements.define('mms-subscription-details', class extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('product-info');
      this.dialog = this.querySelector('dialog');
      if (!this.scope || !this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.matchesArticle = link => {
        try {
          const url = new URL(link.href, window.location.origin);
          return url.protocol === 'https:' && url.hostname === 'www.sealsubscriptions.com' && url.pathname === '/articles/how-subscriptions-work'
            || url.protocol === 'https:' && url.hostname === 'sealsubscriptions.com' && url.pathname === '/articles/how-subscriptions-work';
        } catch (_) { return false; }
      };
      this.enhance = () => {
        let ready = false;
        for (const link of this.scope.querySelectorAll('a[href]')) {
          if (!this.matchesArticle(link)) continue;
          link.setAttribute('aria-haspopup', 'dialog');
          link.setAttribute('aria-controls', this.dialog.id);
          if (link.closest('.sls-subscription-details-label')) ready = true;
        }
        this.scope.toggleAttribute('data-mms-subscription-details-ready', ready);
      };
      this.openDetails = event => {
        const link = event.target.closest('a[href]');
        if (!link || !this.scope.contains(link) || !this.matchesArticle(link) || !this.dialog.isConnected) return;
        if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        try { this.dialog.showModal(); } catch (_) { return; }
        event.preventDefault();
        event.stopPropagation();
        this.trigger = link;
        this.dialog.querySelector('[data-subscription-close]').focus();
      };
      this.closeDetails = () => this.dialog.close();
      this.returnFocus = () => { if (this.trigger?.isConnected) this.trigger.focus(); };
      this.scope.addEventListener('click', this.openDetails, true);
      this.dialog.querySelector('[data-subscription-close]').addEventListener('click', this.closeDetails);
      this.dialog.addEventListener('close', this.returnFocus);
      this.observer = new MutationObserver(() => this.enhance());
      this.observer.observe(this.scope, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
      this.enhance();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.scope?.removeAttribute('data-mms-subscription-details-ready');
      this.scope?.removeEventListener('click', this.openDetails, true);
      this.dialog?.querySelector('[data-subscription-close]')?.removeEventListener('click', this.closeDetails);
      this.dialog?.removeEventListener('close', this.returnFocus);
    }
  });
}
